'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/initUspBanner'));
    processInclude(require('./search/backToTop'));
    processInclude(require('./search/search'));
});
